export default "__VITE_ASSET__D3OQYk4G__"